import QuillEditor from "components/QuillEditor/QuillEditor";
import { TIME_FORMAT } from "constants/date";
import dayjs from "dayjs";
import { useMemo, useRef } from "react";
import { LastNoteProps } from "types/Models/TaskTracker";

const getDateTime = (dateString: string) => {
  const isToday = dayjs(dateString).isToday();
  if (isToday) {
    return dayjs(dateString).format(TIME_FORMAT);
  }
  return dayjs(dateString).format("MMM DD, YYYY h:mm A");
};

export const RecentNote = ({
  lastNote,
}: {
  lastNote: LastNoteProps | null;
}) => {
  const quillRefItem = useRef(null);

  const formattedNotes = useMemo(() => {
    let notes = "";
    if (lastNote?.last_task_note_content) {
      try {
        notes = JSON.parse(lastNote.last_task_note_content);
      } catch (error) {
        notes = last_task_note_content || "";
      }
    }
    return notes;
  }, [lastNote?.last_task_note_content]);

  if (!lastNote) {
    return "-";
  }
  const {
    last_task_note_content,
    last_task_note_created_at,
    last_note_created_by,
  } = lastNote || {};

  if (
    !last_task_note_content ||
    !last_task_note_created_at ||
    !last_note_created_by
  ) {
    return "-";
  }

  return (
    <div className="t-min-w-52 t-space-y-0.5 t-mr-2 recentNote">
      <div className="t-flex t-justify-between t-items-center t-gap-4">
        <div className="t-text-subtext-sm t-text-neutral-70 t-truncate t-flex-1">
          {last_note_created_by.name}
        </div>
        <div className="t-text-caption t-text-neutral-70 t-min-w-fit">
          {getDateTime(last_task_note_created_at)}
        </div>
      </div>
      <div className="t-text-body-sm t-text-text-30 t-line-clamp-2">
        <QuillEditor
          initReadOnly
          theme="bubble"
          defaultValue={formattedNotes}
          parentRef={quillRefItem}
        />
        {}
      </div>
    </div>
  );
};
